export default "__VITE_ASSET__myKaAek0__"